import { supabase } from "@/platform/lib/supabase";

/**
 * URL pública do PNG de uma página renderizada (bucket usp-question-assets).
 */
export function pageImagePublicUrl(storagePath: string): string {
  const base = import.meta.env.VITE_SUPABASE_URL ?? "";
  return `${base}/storage/v1/object/public/usp-question-assets/${storagePath}`;
}

/**
 * Dado um conjunto de questões com { id, exam_paper_id, page_number },
 * devolve um Record<questionId, pageImageUrl> apenas para as que têm
 * page_number + render disponível em usp_paper_pages.
 */
export async function fetchQuestionPageImages(
  questions: Array<{
    id: string;
    exam_paper_id?: string | null;
    page_number?: number | null;
  }>,
): Promise<Record<string, string>> {
  const pairs = questions.filter((q) => q.exam_paper_id && q.page_number != null);
  if (pairs.length === 0) return {};

  const paperIds = Array.from(new Set(pairs.map((q) => q.exam_paper_id as string)));
  const pageNumbers = Array.from(new Set(pairs.map((q) => q.page_number as number)));

  const { data, error } = await supabase
    .from("usp_paper_pages")
    .select("exam_paper_id, page_number, storage_path")
    .in("exam_paper_id", paperIds)
    .in("page_number", pageNumbers);
  if (error || !data) return {};

  const byKey = new Map<string, string>(
    (data as Array<{ exam_paper_id: string; page_number: number; storage_path: string }>).map((p) => [
      `${p.exam_paper_id}:${p.page_number}`,
      p.storage_path,
    ]),
  );

  const out: Record<string, string> = {};
  for (const q of pairs) {
    const sp = byKey.get(`${q.exam_paper_id}:${q.page_number}`);
    if (sp) out[q.id] = pageImagePublicUrl(sp);
  }
  return out;
}
